import {
  Box,
  Card,
  CardContent,
  Typography,
} from '@mui/material';
import PrePlansMap from '../../components/PrePlansMap';

const PrePlansAndInspections = () => {


  return (
   
      <Card className="shadow p-3 mt-3" sx={{ height: 'calc(100vh - 27px)' }}>
        <CardContent className="p-0 " sx={{ height: '100%' }}>
          <Typography
            variant="h5"
            className="mb-2 mb-3"
            sx={{ fontWeight: 700 }}
          >
            Pre Plans and Inspections
          </Typography>

          <PrePlansMap />
        </CardContent>
      </Card>
 
  );
};

export default PrePlansAndInspections;
